import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "timeline-axis" }
const _hoisted_3 = ["data-qa"]
const _hoisted_4 = { class: "timeline-content" }
const _hoisted_5 = ["data-qa"]
const _hoisted_6 = ["data-qa"]
const _hoisted_7 = { class: "timeline-date-time" }
const _hoisted_8 = ["data-qa"]
const _hoisted_9 = ["data-qa"]

import { computed, nextTick, ref } from "vue";
import { addHours, format } from "date-fns";
import ru from "date-fns/locale/ru";
import store from "@/store/index";
import { ExchangeWeb, ExchangeWebUser } from "@/types/beru";
import VitaIcon from "./UI/VitaIcon.vue";

interface TimelineItem {
  status: string;
  user: string;
  date: string;
  time: string;
  dotClass: string;
  qaLabel: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaBeruTimeline',
  props: {
    exchangeWeb: {}
  },
  emits: ["toggle"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const timelineExpanded = ref(false);

const pharmTz = computed<number>(() => store.getters["data/pharmTz"] || 0);

const toPharmDate = (iso: string): Date => {
  const timeZone = pharmTz.value + new Date().getTimezoneOffset() / 60;
  return addHours(new Date(iso), timeZone);
};

// Получаем строку с ФИО и подразделением
const formatUser = (user: ExchangeWebUser): string => {
  const initials = [user.firstName, user.middleName]
    .filter(Boolean)
    .map((name) => `${name[0]}.`)
    .join("");
  const fullName = [user.lastName, initials].filter(Boolean).join(" ");
  const namePodr = user.serviceNumbers?.namePodr;
  return namePodr ? `${fullName} (${namePodr})` : fullName;
};

const timelineItems = computed<TimelineItem[]>(() =>
  props.exchangeWeb.flatMap((exchange) => {
    const statuses = [
      {
        status: "Взята",
        date: exchange.createdAt,
        dotClass: "is-current",
        qaLabel: "taken",
      },
      {
        status: "Согласована",
        date: exchange.confirmedAt,
        dotClass: "is-completed",
        qaLabel: "confirmed",
      },
      {
        status: "Отменена",
        date: exchange.deletedAt,
        dotClass: "",
        qaLabel: "canceled",
      },
    ]
      .filter(
        (
          item,
        ): item is {
          status: string;
          date: string;
          dotClass: string;
          qaLabel: string;
        } => Boolean(item.date),
      )
      .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

    return statuses.map((item) => ({
      status: item.status,
      user: formatUser(exchange.user),
      date: format(toPharmDate(item.date), "d MMMM yyyy", { locale: ru }),
      time: format(toPharmDate(item.date), "HH:mm"),
      dotClass: item.dotClass,
      qaLabel: item.qaLabel,
    }));
  }),
);

const onExpandTimelineClick = async () => {
  timelineExpanded.value = !timelineExpanded.value;
  await nextTick();
  emit("toggle", timelineExpanded.value);
};

return (_ctx: any,_cache: any) => {
  return (timelineItems.value.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["timeline", { 'is-expanded': timelineExpanded.value }]),
        "data-qa": "beru-timeline-block"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timelineItems.value, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "timeline-item",
            key: idx,
            "data-qa": `beru-timeline-item-${item.qaLabel}-block`
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(["timeline-dot", item.dotClass]),
                "data-qa": `beru-timeline-item-${item.qaLabel}-dot`
              }, null, 10, _hoisted_3)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "timeline-title",
                "data-qa": `beru-timeline-item-${item.qaLabel}-status`
              }, _toDisplayString(item.status), 9, _hoisted_5),
              _createElementVNode("div", {
                class: "timeline-desc",
                "data-qa": `beru-timeline-item-${item.qaLabel}-user`
              }, _toDisplayString(item.user), 9, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "timeline-date",
                "data-qa": `beru-timeline-item-${item.qaLabel}-date`
              }, _toDisplayString(item.date), 9, _hoisted_8),
              _createElementVNode("div", {
                class: "timeline-time",
                "data-qa": `beru-timeline-item-${item.qaLabel}-time`
              }, _toDisplayString(item.time), 9, _hoisted_9)
            ])
          ], 8, _hoisted_1))
        }), 128)),
        (timelineItems.value.length > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "timeline-expand",
              onClick: onExpandTimelineClick,
              "data-qa": "beru-timeline-button-expand-toggle"
            }, [
              _createVNode(VitaIcon, { name: "chevron-blue-down" }),
              _createElementVNode("span", null, _toDisplayString(timelineExpanded.value ? "Свернуть" : "Показать все статусы"), 1)
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})